import { Column, PrimaryColumn } from 'typeorm';

export abstract class StateEntity {
  @PrimaryColumn('text')
  id!: string;
  @Column('text')
  json!: string;
}
